export function normalizeStatusDate(value) {
  if (!value) return null
  const date =
    value instanceof Date ? new Date(value) : new Date(String(value).slice(0, 10) + 'T00:00:00')
  if (Number.isNaN(date.getTime())) return null
  date.setHours(0, 0, 0, 0)
  return date
}

function latestDate(values) {
  const dates = values.map(normalizeStatusDate).filter(Boolean)
  return dates.length ? new Date(Math.max(...dates.map((date) => date.getTime()))) : null
}

export function getRepairStatusMinDate(file) {
  return latestDate([
    file.last_status_update_date,
    file.finalization_date,
    file.business_created_at || file.created_at
  ])
}

export function getRentalStatusMinDate(file) {
  return latestDate([
    file.rental_last_status_update_date,
    file.rental_created_date,
    file.rental_client_informed_date
  ])
}

export function isStatusUpdateDateValid(value, minimum, maximum = new Date()) {
  const date = normalizeStatusDate(value)
  const min = normalizeStatusDate(minimum)
  const max = normalizeStatusDate(maximum)
  return Boolean(date && (!min || date >= min) && (!max || date <= max))
}
